import apiClient from "./api";

export interface MembershipCard {
  id?: number;
  customer_id: number | null;
  customer_name?: string | null;
  customer?: {
    id?: number;
    name?: string;
  } | null;
  card_name: string;
  card_number: string;
  balance: number;
  status: number | boolean;
  issued_at?: string | null;
  expiry_date?: string | null;
  note?: string | null;
  last_used_at?: string | null;
  created_at?: string;
  updated_at?: string;
}

export interface MembershipCardFilters {
  customer_id?: number | null;
  status?: number;
  active_only?: boolean;
}

export interface MembershipCardPayload {
  customer_id: number | null;
  card_name: string;
  card_number: string;
  balance: number;
  status: number;
  issued_at?: string | null;
  expiry_date?: string | null;
  note?: string | null;
}

const normalizeApiList = <T>(payload: unknown): T[] => {
  const apiPayload = payload as {
    data?: {
      data?: unknown;
    } | unknown;
  };
  const value =
    (apiPayload?.data as { data?: unknown } | undefined)?.data ??
    apiPayload?.data ??
    payload;
  return Array.isArray(value) ? value : [];
};

const membershipCardService = {
  async getMembershipCards(
    filters: MembershipCardFilters = {}
  ): Promise<MembershipCard[]> {
    const response = await apiClient.get("/membership-cards", {
      params: filters,
    });
    return normalizeApiList<MembershipCard>(response);
  },

  async getAvailableMembershipCards(
    filters: MembershipCardFilters = {}
  ): Promise<MembershipCard[]> {
    const response = await apiClient.get("/membership-cards/available", {
      params: filters,
    });
    return normalizeApiList<MembershipCard>(response);
  },

  async getMembershipCard(id: number): Promise<MembershipCard> {
    const response = await apiClient.get(`/membership-cards/${id}`);
    return response.data?.data ?? response.data;
  },

  async createMembershipCard(
    payload: MembershipCardPayload
  ): Promise<MembershipCard> {
    const response = await apiClient.post("/membership-cards", payload);
    return response.data?.data ?? response.data;
  },

  async updateMembershipCard(
    id: number,
    payload: MembershipCardPayload
  ): Promise<MembershipCard> {
    const response = await apiClient.put(`/membership-cards/${id}`, payload);
    return response.data?.data ?? response.data;
  },

  async deleteMembershipCard(id: number): Promise<void> {
    await apiClient.delete(`/membership-cards/${id}`);
  },
};

export default membershipCardService;
